import axios, { AxiosResponse } from 'axios'

import { SummaryReportResponse } from '@/api/manual_types'

import {
  ReportInstanceId,
  ReportInstanceRead,
  ReportInstanceWrite,
  ReportScheduleId,
  ReportScheduleRead,
  ReportScheduleWrite,
  SummaryReportParameters,
} from '@generated/types'

// Import specific manual type if needed

const INSTANCE_BASE_URL = '/api/report'
const SCHEDULE_BASE_URL = '/api/report-schedule'
const SUMMARY_BASE_URL = '/api/summary'

export default {
  // Summary Report
  async getSummary({
    start,
    end,
  }: SummaryReportParameters): Promise<AxiosResponse<SummaryReportResponse>> {
    return axios.get(`${SUMMARY_BASE_URL}/?start=${start}&end=${end}`)
  },

  // Report Instances (Generated Reports)
  async createInstance(report: ReportInstanceWrite): Promise<AxiosResponse<ReportInstanceRead>> {
    return axios.post(`${INSTANCE_BASE_URL}/`, report)
  },

  async getInstance(id: ReportInstanceId): Promise<AxiosResponse<ReportInstanceRead>> {
    return axios.get(`${INSTANCE_BASE_URL}/${id}/`)
  },

  async listInstances(): Promise<AxiosResponse<ReportInstanceRead[]>> {
    return axios.get(`${INSTANCE_BASE_URL}/`)
  },

  // Report Schedules
  async createSchedule(schedule: ReportScheduleWrite): Promise<AxiosResponse<ReportScheduleRead>> {
    return axios.post(`${SCHEDULE_BASE_URL}/`, schedule)
  },

  async listSchedules(): Promise<AxiosResponse<ReportScheduleRead[]>> {
    return axios.get(`${SCHEDULE_BASE_URL}/`)
  },

  async updateSchedule(schedule: ReportScheduleWrite): Promise<AxiosResponse<ReportScheduleRead>> {
    // Ensure schedule.id exists before using it in the URL
    if (schedule.id === undefined || schedule.id === null) {
      return Promise.reject(new Error('Report schedule ID is required for update.'))
    }
    return axios.put(`${SCHEDULE_BASE_URL}/${schedule.id}/`, schedule)
  },

  async deleteSchedule(id: ReportScheduleId): Promise<AxiosResponse> {
    return axios.delete(`${SCHEDULE_BASE_URL}/${id}/`)
  },
}
